import styled from "../Themes";

const Bold = styled(`b`)`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.color.font_bold[2]};
`;

export default Bold;
